define("preview-grid/models/ig-post", ["exports", "@ember/object", "@ember/utils", "ember-api-actions", "tracked-built-ins", "later/utils/secure-url", "later/models/ig-preview-post", "later/utils/formatters/caption-from-regram"], function (_exports, _object, _utils, _emberApiActions, _trackedBuiltIns, _secureUrl, _igPreviewPost, _captionFromRegram) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _dec21, _dec22, _dec23, _dec24, _dec25, _dec26, _dec27, _dec28, _class;

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  const LOW_RES_THRESHOLD = 500;
  let IgPost = (_dec = (0, _object.computed)('createdMoment'), _dec2 = (0, _object.computed)('createdMoment'), _dec3 = (0, _object.computed)('caption', 'username', 'link', 'instagramProfiles'), _dec4 = (0, _object.computed)('caption'), _dec5 = (0, _object.computed)('createdTime'), _dec6 = (0, _object.computed)('createdTime'), _dec7 = (0, _object.computed)('createdMoment'), _dec8 = (0, _object.computed)('commentCount', 'likeCount'), _dec9 = (0, _object.computed)('linkinbioPost'), _dec10 = (0, _object.computed)('locationId'), _dec11 = (0, _object.computed)('pagingInfo'), _dec12 = (0, _object.computed)('account'), _dec13 = (0, _object.computed)('type'), _dec14 = (0, _object.computed)('type'), _dec15 = (0, _object.computed)('type'), _dec16 = (0, _object.computed)('mediaProductType', 'permalink'), _dec17 = (0, _object.computed)('mediaProductType'), _dec18 = (0, _object.computed)('width', 'height'), _dec19 = (0, _object.computed)('username', 'instagramProfiles'), _dec20 = (0, _object.computed)('createdMoment'), _dec21 = (0, _object.computed)('createdMoment'), _dec22 = (0, _object.computed)('lowBandwidthVideoUrl'), _dec23 = (0, _object.computed)('lowResUrl'), _dec24 = (0, _object.computed)('lowResVideoUrl'), _dec25 = (0, _object.computed)('standardResUrl'), _dec26 = (0, _object.computed)('standardResVideoUrl'), _dec27 = (0, _object.computed)('thumbUrl'), _dec28 = (0, _object.computed)('createdTime'), (_class = class IgPost extends _object.default {
    constructor() {
      super(...arguments);

      _defineProperty(this, "account", null);

      _defineProperty(this, "caption", null);

      _defineProperty(this, "carouselMediaItems", new _trackedBuiltIns.TrackedArray());

      _defineProperty(this, "commentCount", 0);

      _defineProperty(this, "createdTime", null);

      _defineProperty(this, "followersOnPost", null);

      _defineProperty(this, "id", null);

      _defineProperty(this, "igId", null);

      _defineProperty(this, "isIGPost", true);

      _defineProperty(this, "likeCount", 0);

      _defineProperty(this, "link", null);

      _defineProperty(this, "linkinbioClicks", null);

      _defineProperty(this, "linkinbioMediaId", null);

      _defineProperty(this, "linkinbioPost", null);

      _defineProperty(this, "linkinbioPostId", null);

      _defineProperty(this, "locationId", null);

      _defineProperty(this, "locationName", null);

      _defineProperty(this, "lowBandwidthVideoUrl", null);

      _defineProperty(this, "lowResUrl", null);

      _defineProperty(this, "lowResVideoUrl", null);

      _defineProperty(this, "pagingInfo", null);

      _defineProperty(this, "permalink", null);

      _defineProperty(this, "socialProfile", null);

      _defineProperty(this, "standardResVideoUrl", null);

      _defineProperty(this, "thumbUrl", null);

      _defineProperty(this, "timeCollected", null);

      _defineProperty(this, "type", null);

      _defineProperty(this, "userHasLiked", false);

      _defineProperty(this, "userId", null);

      _defineProperty(this, "username", null);

      _defineProperty(this, "userProfileUrl", null);

      _defineProperty(this, "userTags", new _trackedBuiltIns.TrackedArray());

      _defineProperty(this, "verify", (0, _emberApiActions.memberAction)({
        path: 'verify',
        type: 'post'
      }));
    }

    get analyticsChartFormattedCreatedTime() {
      return this.formatCreatedTime('MMM D/YY, h:mma');
    }

    get analyticsDetailFormattedCreatedTime() {
      return this.formatCreatedTime('MMM. D, YYYY, h:mma');
    }

    get captionText() {
      const {
        caption,
        link
      } = this;
      let {
        username
      } = this;

      if (this.isOwnPost) {
        username = null;
      }

      return (0, _captionFromRegram.default)({
        caption,
        username,
        link
      });
    }

    get captionTruncated() {
      const {
        caption
      } = this;

      if (caption && caption.length > 100) {
        return caption.substring(0, 100) + '...';
      }

      return caption;
    }

    get createdMoment() {
      return moment(this.createdTime * 1000);
    }

    get displayTime() {
      return parseInt(this.createdTime);
    }

    get formattedTimeSinceCreated() {
      return moment(this.formatCreatedTime('ddd, MMM D YYYY LT')).fromNow();
    }

    get hasCommentsAndLikes() {
      return Object.prototype.hasOwnProperty.call(this, 'commentCount') && Object.prototype.hasOwnProperty.call(this, 'likeCount');
    }

    get hasLinkinbioPost() {
      return !(0, _utils.isEmpty)(this.linkinbioPost);
    }

    get hasLocation() {
      return !(0, _utils.isNone)(this.locationId);
    }

    get hasMoreComments() {
      return !(0, _utils.isEmpty)(this.pagingInfo);
    }

    get instagramProfiles() {
      var _this$account;

      return (_this$account = this.account) === null || _this$account === void 0 ? void 0 : _this$account.instagramProfiles;
    }

    get isCarouselPost() {
      return this.type.toLowerCase() === 'carousel_album';
    }

    get isImage() {
      return this.type.toLowerCase() === 'image';
    }

    get isVideo() {
      return this.type.toLowerCase() === 'video';
    }

    get isReels() {
      var _this$permalink;

      return this.mediaProductType === 'REELS' || ((_this$permalink = this.permalink) === null || _this$permalink === void 0 ? void 0 : _this$permalink.includes('/reel/'));
    }

    get isIGTV() {
      return this.mediaProductType === 'IGTV';
    }

    get isLowRes() {
      if (!this.width || !this.height) {
        return false;
      }

      return this.width < LOW_RES_THRESHOLD && this.height < LOW_RES_THRESHOLD;
    }

    get isOwnPost() {
      if (this.instagramProfiles) {
        return this.instagramProfiles.any(profile => (0, _utils.isEqual)(this.username, profile.nickname));
      }

      return false;
    }

    get manualMatchingFormattedCreatedDate() {
      return this.formatCreatedTime('MMM D YYYY');
    }

    get manualMatchingFormattedCreatedTime() {
      return this.formatCreatedTime('h:mm A');
    }

    get secureLowBandwitdhVideoUrl() {
      return (0, _secureUrl.secureUrl)(this.lowBandwidthVideoUrl);
    }

    get secureLowResUrl() {
      return (0, _secureUrl.secureUrl)(this.lowResUrl);
    }

    get secureLowResVideoUrl() {
      return (0, _secureUrl.secureUrl)(this.lowResVideoUrl);
    }

    get secureStandardResUrl() {
      return (0, _secureUrl.secureUrl)(this.standardResUrl);
    }

    get secureStandardResVideoUrl() {
      return (0, _secureUrl.secureUrl)(this.standardResVideoUrl);
    }

    get secureThumbUrl() {
      return (0, _secureUrl.secureUrl)(this.thumbUrl);
    }

    get yearMonthFormattedCreatedTime() {
      return moment.unix(this.createdTime).format('YYYY-MM');
    }

    formatCreatedTime(format) {
      return this.createdMoment.format(format);
    }

    igPreviewPost() {
      return _igPreviewPost.default.create({
        id: 'ig-post-' + this.id,
        socialProfile: this.socialProfile,
        igPost: this,
        scheduledTime: parseInt(this.createdTime)
      });
    }

  }, (_applyDecoratedDescriptor(_class.prototype, "analyticsChartFormattedCreatedTime", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "analyticsChartFormattedCreatedTime"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "analyticsDetailFormattedCreatedTime", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "analyticsDetailFormattedCreatedTime"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "captionText", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "captionText"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "captionTruncated", [_dec4], Object.getOwnPropertyDescriptor(_class.prototype, "captionTruncated"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "createdMoment", [_dec5], Object.getOwnPropertyDescriptor(_class.prototype, "createdMoment"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "displayTime", [_dec6], Object.getOwnPropertyDescriptor(_class.prototype, "displayTime"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "formattedTimeSinceCreated", [_dec7], Object.getOwnPropertyDescriptor(_class.prototype, "formattedTimeSinceCreated"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasCommentsAndLikes", [_dec8], Object.getOwnPropertyDescriptor(_class.prototype, "hasCommentsAndLikes"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasLinkinbioPost", [_dec9], Object.getOwnPropertyDescriptor(_class.prototype, "hasLinkinbioPost"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasLocation", [_dec10], Object.getOwnPropertyDescriptor(_class.prototype, "hasLocation"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasMoreComments", [_dec11], Object.getOwnPropertyDescriptor(_class.prototype, "hasMoreComments"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "instagramProfiles", [_dec12], Object.getOwnPropertyDescriptor(_class.prototype, "instagramProfiles"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isCarouselPost", [_dec13], Object.getOwnPropertyDescriptor(_class.prototype, "isCarouselPost"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isImage", [_dec14], Object.getOwnPropertyDescriptor(_class.prototype, "isImage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isVideo", [_dec15], Object.getOwnPropertyDescriptor(_class.prototype, "isVideo"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isReels", [_dec16], Object.getOwnPropertyDescriptor(_class.prototype, "isReels"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isIGTV", [_dec17], Object.getOwnPropertyDescriptor(_class.prototype, "isIGTV"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isLowRes", [_dec18], Object.getOwnPropertyDescriptor(_class.prototype, "isLowRes"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isOwnPost", [_dec19], Object.getOwnPropertyDescriptor(_class.prototype, "isOwnPost"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "manualMatchingFormattedCreatedDate", [_dec20], Object.getOwnPropertyDescriptor(_class.prototype, "manualMatchingFormattedCreatedDate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "manualMatchingFormattedCreatedTime", [_dec21], Object.getOwnPropertyDescriptor(_class.prototype, "manualMatchingFormattedCreatedTime"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "secureLowBandwitdhVideoUrl", [_dec22], Object.getOwnPropertyDescriptor(_class.prototype, "secureLowBandwitdhVideoUrl"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "secureLowResUrl", [_dec23], Object.getOwnPropertyDescriptor(_class.prototype, "secureLowResUrl"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "secureLowResVideoUrl", [_dec24], Object.getOwnPropertyDescriptor(_class.prototype, "secureLowResVideoUrl"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "secureStandardResUrl", [_dec25], Object.getOwnPropertyDescriptor(_class.prototype, "secureStandardResUrl"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "secureStandardResVideoUrl", [_dec26], Object.getOwnPropertyDescriptor(_class.prototype, "secureStandardResVideoUrl"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "secureThumbUrl", [_dec27], Object.getOwnPropertyDescriptor(_class.prototype, "secureThumbUrl"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "yearMonthFormattedCreatedTime", [_dec28], Object.getOwnPropertyDescriptor(_class.prototype, "yearMonthFormattedCreatedTime"), _class.prototype)), _class));
  _exports.default = IgPost;
});